import axios from '@axios'

const route = 'register/rate_plan'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}`)
    },
    store(context, payload) {
      return axios.post(route, payload)
    },
    update(context, payload) {
      return axios.put(`${route}/${payload.id}`, payload)
    },
    delete(context, payload) {
      return axios.delete(`${route}/${payload.id}`)
    },
    getForSelect() {
      return axios.get(`${route}/select`)
    },
    listSpecialRates(context, { ratePlanId, categoryId }) {
      return axios.get(`${route}/${ratePlanId}/categories/${categoryId}/special-rates`)
    },
    storeSpecialRates(context, {
      ratePlanId, categoryId, price, dates,
    }) {
      return axios.post(`${route}/${ratePlanId}/categories/${categoryId}/special-rates`, { price, dates })
    },
    deleteSpecialRate(context, { ratePlanId, categoryId, rateId }) {
      return axios.delete(`${route}/${ratePlanId}/categories/${categoryId}/special-rates/${rateId}`)
    },
  },
}
